import { GenData, QSingle } from '@educraft/base';
import { SimpleGenSingle } from '../../genEq/genHelper';

export const LangUnitUtil = {
  slovan: (amount: number, opt1: string, opt24: string, opt5: string): string => {
    let suffix = opt5;
    if (amount === 1) suffix = opt1;
    else if (amount >= 2 && amount <= 4) suffix = opt24;
    return `${amount} ${suffix}`;
  },
  hours: (amount: number, lang: Record<string, string>): string => {
    const h1 = lang.Unit_Hour_1 ?? 'hodina';
    const h24 = lang.Unit_Hour_2_4 ?? 'hodiny';
    const h5 = lang.Unit_Hour_5 ?? 'hodin';
    return LangUnitUtil.slovan(amount, h1, h24, h5);
  },
  minutes: (amount: number, lang: Record<string, string>): string => {
    const m1 = lang.Unit_Minute_1 ?? 'minuta';
    const m24 = lang.Unit_Minute_2_4 ?? 'minuty';
    const m5 = lang.Unit_Minute_5 ?? 'minut';
    return LangUnitUtil.slovan(amount, m1, m24, m5);
  },
};

export const Mat_Hours_TimeToEvent_Base = {
  timeToEvent:
    (currentWholeHour = false, underOneHour = false, minutes = 1, maxHours = 4) =>
    (data: GenData): QSingle => {
      const r = data.random;
      const {lang} = data;

      const currentHour = r.next(0, 24);
      const currentMinute = currentWholeHour ? 0 : r.next(0, 60 / minutes) * minutes;

      let startHour, startMinute;
      if (underOneHour) {
        startHour = currentHour;
        const sm = r.next(currentMinute + minutes, 60);
        startMinute = Math.floor(sm / minutes) * minutes;
        if (startMinute <= currentMinute) {
          startMinute += minutes;
          if (startMinute >= 60) {
            startMinute -= 60;
            startHour = (startHour + 1) % 24;
          }
        }
      } else {
        const maxStartHour = Math.min(currentHour + maxHours, 23);
        startHour = r.next(currentHour, maxStartHour + 1);
        startMinute = r.next(0, 60 / minutes) * minutes;
        if (startHour === currentHour && startMinute <= currentMinute) {
          startMinute += minutes;
          if (startMinute >= 60) {
            startMinute -= 60;
            startHour = (startHour + 1) % 24;
          }
        }
      }

      const totalCurrent = currentHour * 60 + currentMinute;
      let totalStart = startHour * 60 + startMinute;
      if (totalStart < totalCurrent) totalStart += 24 * 60;

      const diffTotal = totalStart - totalCurrent;
      const diffHours = Math.floor(diffTotal / 60);
      const diffMinutes = diffTotal % 60;

      const pad = (n: number) => n.toString().padStart(2, '0');
      const timeNow = lang.Time_Now ?? "It's exactly";
      const eventStarts = lang.Time_EventStarts ?? 'Event starts at';
      const remaining = lang.Time_Remaining ?? 'Remaining';
      const timeAnd = lang.Time_And ?? 'and';
      const text = `${timeNow} ${pad(currentHour)}:${pad(currentMinute)}. ${eventStarts} ${pad(startHour)}:${pad(startMinute)}. ${remaining}`;
      const answer = `${LangUnitUtil.hours(diffHours, lang)} ${timeAnd} ${LangUnitUtil.minutes(diffMinutes, lang)}`;

      return { texts: [text], answer };
    },
};

export class Math_Clock_TimeLeft__Base extends SimpleGenSingle {
  constructor() {
    super(Mat_Hours_TimeToEvent_Base.timeToEvent(), 'Math_Clock_TimeLeft__Base');
  }
}
export class Math_Clock_TimeLeft__Hours extends SimpleGenSingle {
  constructor() {
    super(Mat_Hours_TimeToEvent_Base.timeToEvent(true, false, 60), 'Math_Clock_TimeLeft__Hours');
  }
}
export class Math_Clock_TimeLeft__Minutes extends SimpleGenSingle {
  constructor() {
    super(Mat_Hours_TimeToEvent_Base.timeToEvent(false, true), 'Math_Clock_TimeLeft__Minutes');
  }
}
export class Math_Clock_TimeLeft__Minutes5 extends SimpleGenSingle {
  constructor() {
    super(Mat_Hours_TimeToEvent_Base.timeToEvent(false, false, 5), 'Math_Clock_TimeLeft__Minutes5');
  }
}
